import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import Register from "../views/Register.vue";
import Ec from "../views/Ec.vue";
import Vv from "../views/Vv.vue";
import Result from "../views/Result.vue";
import Help from "../views/Help.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Ec,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
  },
  {
    path: "/ec",
    name: "Ec",
    component: Ec,
  },
  {
    path: "/vv",
    name: "Vv",
    component: Vv,
  },
  {
    path: "/result",
    name: "Result",
    component: Result,
  },
  {
    path: "/help",
    name: "Help",
    component: Help,
  },
];

const router = new VueRouter({
  routes,
});

export default router;
